import { Box, IconButton, CloseIcon, MenuIcon, StarRateIcon, Slide, HandbookSearchBar } from "src/components";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ChaptersTab from './chapters-tab';
import BookmarksTab from './bookmarks-tab';
import { useIsMobile } from 'src/hooks';

export default function HandbookMenu({ handbookMenuTab, onClose }) {
    const [menuTab, setMenuTab] = useState(handbookMenuTab || 'chapters');

    const isMobile = useIsMobile();
    const navigate = useNavigate(); 
    const showChapters = menuTab === 'chapters';   

    const handleCategoryClick = (slug) => {
        navigate(`/handbook/${slug}`);
        onClose();
    };

    const handleArticleClick = (categorySlug, articleSlug) => {
        if (categorySlug === articleSlug) {
            navigate(`/handbook/${categorySlug}`);
        }
        else {
            navigate(`/handbook/${categorySlug}/${articleSlug}`);
        }
        onClose();
    };

    return (
        <Box sx={{ width: '100%', height: "100%", pl: 2, pr: 2, pt: 2, marginTop: 'var(--safe-area-top)' }}>

            <Box sx={{
                position: 'absolute',
                top: isMobile ? 'calc(48px + var(--safe-area-top))' : 12,
                right: isMobile ? 16 : 12,
                width: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'flex-end'}}>

                {showChapters ?
                    <IconButton onClick={() => setMenuTab('bookmarks')} size="small">
                        <StarRateIcon fontSize={isMobile ? undefined : "inherit"} color="primary" />
                    </IconButton>

                :   <IconButton onClick={() => setMenuTab('chapters')} size="small">
                        <MenuIcon fontSize={isMobile ? undefined : "inherit"} />
                    </IconButton>
                }

                <IconButton 
                    onClick={onClose}
                    size="small" >
                        <CloseIcon fontSize={isMobile ? undefined : "inherit"}/>
                </IconButton>

            </Box>

            {isMobile && (
                <Box sx={{ 
                        mb: 3, 
                        mt: 2,
                        mr: '60px'}}>
                    <HandbookSearchBar 
                        inputColor="#000" 
                        borderColor="primary.main" 
                        closeDialogOnSearch={true}
                        onClose={onClose}/>
                </Box>
            )}

            <Box sx={{overflowX: 'hidden'}}>

                <Slide direction="right" in={showChapters} mountOnEnter unmountOnExit>
                    <div>
                        <ChaptersTab handleCategoryClick={handleCategoryClick} />
                    </div>
                </Slide>

                <Slide direction="left" in={!showChapters} mountOnEnter unmountOnExit>
                    <div>
                        <BookmarksTab handleCategoryClick={handleCategoryClick} handleArticleClick={handleArticleClick} />
                    </div>
                </Slide>

            </Box>

        </Box>
    );
}
